module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "tab-remittance-detail"
    }
  }, [_c('div', {
    class: {
      'remittance-detail': _vm.showRemovalButton
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-10 margin-container"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.nomeArquivo'))
    }
  }), _c('h4', {
    staticClass: "detail-value break-all"
  }, [_vm._v(_vm._s(_vm.remittance.nomeArquivo))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.idRemessa'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.id))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.resultado'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.resultado.' + _vm.remittance.situacao)))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.usuario'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.usuario ? _vm.remittance.usuario.nome : '-'))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.conteudo'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.movFinanConfig.nome))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.sequencia'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.sequencia))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.periodoContabil'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.periodoContabil ? _vm.remittance.periodoContabil.anoMesFormatado : '-'))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.dataMovimentacaoInicial'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.handleDate(_vm.remittance.dataMovimentoInicial)))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.dataMovimentacaoFinal'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.handleDate(_vm.remittance.dataMovimentoFinal)))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.dataGeracaoArquivo'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.handleDateFull(_vm.remittance.dataCriacao)))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.dataBase'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.handleDate(_vm.remittance.dataBase)))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.observacao'))
    }
  }), _c('h4', {
    staticClass: "detail-value font-default"
  }, [_vm._v(_vm._s(_vm.remittance.observacao))])])])])]), (_vm.showRemovalButton) ? _c('div', {
    staticClass: "tab-footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('remessaIntegracao.titulos.excluirRemessa'),
      "id": "btnExcluirArquivo",
      "clickFunction": _vm.openModalConfirm
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17392d8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17392d8c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/integration/remittanceIntegration/tabRemittanceDetail.pug
// module id = 1375
// module chunks = 0